import SiHaDocumentationListPagingResultModelBase from '../_generated/modelBases/si-ha-documentation-list-paging-result-model-base';

export default class SiHaDocumentationListPagingResultModel extends SiHaDocumentationListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
